import { Component, OnInit, OnDestroy } from '@angular/core';
import { KycService } from '@app/core/kyc.service';
import { AgentInfo } from '@app/core/models/agent';
import { Subscription } from 'rxjs';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { googleAnalytics } from '../scripts/ga';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
  agent: AgentInfo;
  subscription: Subscription;

  constructor(
    private _kycService: KycService,
    private router: Router) {
    this.agent = new AgentInfo();

    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this._kycService.browserRefresh = !router.navigated;
      }

      if (event instanceof NavigationEnd) {
        const url = event['urlAfterRedirects'];
        if (url !== null && url !== undefined && url !== '' && url.indexOf('null') < 0) {
          googleAnalytics(url);
        }
      }
    });
  }

  ngOnInit() {
    this._kycService.getAgentInfo().subscribe((value) => {
      this.agent = value;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts